import { UserTelemedicineEligibleGroupType } from '@/models/common';
import { NativePostMessageEvent } from '@/utils/mobile/event.messages';
import { NATIVE_INTERACTION_MESSAGE_TYPE } from '@/utils/mobile/type.messages';

const TEN_SECONDS = 10000;
const TWO_MINUTES = 2 * 60 * 1000;

interface GetLocationPositionAppMessage {
  latitude: number;
  longitude: number;
}

export const nativePostMessageEventList = {
  getRecentKeywordList: <T>(): Promise<T> => {
    return new NativePostMessageEvent.Builder<T>(NATIVE_INTERACTION_MESSAGE_TYPE.GET_RECENT_KEYWORD_LIST)
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrDefault([] as T);
  },
  addRecentKeyword: (keyword: string): Promise<void> => {
    return new NativePostMessageEvent.Builder<void>(NATIVE_INTERACTION_MESSAGE_TYPE.ADD_RECENT_KEYWORD)
      .setPayload<{ keyword: string }>({ keyword })
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrThrow();
  },
  removeRecentKeyword: (keyword: string): Promise<void> => {
    return new NativePostMessageEvent.Builder<void>(NATIVE_INTERACTION_MESSAGE_TYPE.REMOVE_RECENT_KEYWORD)
      .setPayload<{ keyword: string }>({ keyword })
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrThrow();
  },
  removeAllRecentKeyword: (): Promise<void> => {
    return new NativePostMessageEvent.Builder<void>(NATIVE_INTERACTION_MESSAGE_TYPE.REMOVE_ALL_RECENT_KEYWORD)
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrThrow();
  },
  refreshRecentKeywordList: (): Promise<void> => {
    return new NativePostMessageEvent.Builder<void>(NATIVE_INTERACTION_MESSAGE_TYPE.REFRESH_RECENT_KEYWORD_LIST)
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrThrow();
  },
  requestCameraPermission: (): Promise<boolean> => {
    return new NativePostMessageEvent.Builder<boolean>(NATIVE_INTERACTION_MESSAGE_TYPE.REQUEST_CAMERA_PERMISSION)
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrDefault(false);
  },
  checkLocationPermission: (): Promise<boolean> => {
    return new NativePostMessageEvent.Builder<boolean>(NATIVE_INTERACTION_MESSAGE_TYPE.CHECK_LOCATION_PERMISSION)
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrDefault(false);
  },
  getLocationPosition: (): Promise<GetLocationPositionAppMessage> => {
    return new NativePostMessageEvent.Builder<GetLocationPositionAppMessage>(
      NATIVE_INTERACTION_MESSAGE_TYPE.GET_LOCATION_POSITION
    )
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrDefault({
        latitude: 0,
        longitude: 0,
      });
  },
  getLocationPositionOrNull: (): Promise<GetLocationPositionAppMessage | null> => {
    return new NativePostMessageEvent.Builder<GetLocationPositionAppMessage>(
      NATIVE_INTERACTION_MESSAGE_TYPE.GET_LOCATION_POSITION
    )
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrNull();
  },
  requestLocationPermission: (): Promise<GetLocationPositionAppMessage | null> => {
    return new NativePostMessageEvent.Builder<GetLocationPositionAppMessage>(
      NATIVE_INTERACTION_MESSAGE_TYPE.REQUEST_LOCATION_PERMISSION
    )
      .setTimeoutTTL(TEN_SECONDS)
      .build()
      .getOrNull();
  },
  requestTelemedicineEligibleGroupType: (): Promise<UserTelemedicineEligibleGroupType> => {
    return new NativePostMessageEvent.Builder<UserTelemedicineEligibleGroupType>(
      NATIVE_INTERACTION_MESSAGE_TYPE.REQUEST_TELEMEDICINE_ELIGIBLE_GROUP_TYPE
    )
      .setTimeoutTTL(TWO_MINUTES)
      .build()
      .getOrDefault(UserTelemedicineEligibleGroupType.OTHERS);
  },
  requestViewRewardedAd: (missionId: string): Promise<boolean> => {
    return new NativePostMessageEvent.Builder<boolean>(NATIVE_INTERACTION_MESSAGE_TYPE.VIEW_ADVERTISEMENT)
      .setPayload<{
        missionId: string;
      }>({ missionId })
      .setTimeoutTTL(null)
      .build()
      .getOrDefault(false);
  },
};
